import { request } from './http';

export async function getAudits(filters = {}) {
    const queryParams = new URLSearchParams();
    if (filters.SiteID) queryParams.append('SiteID', filters.SiteID);
    if (filters.QuestionID) queryParams.append('QuestionID', filters.QuestionID);
    if (filters.DueDateFrom) queryParams.append('DueDateFrom', filters.DueDateFrom);
    if (filters.DueDateTo) queryParams.append('DueDateTo', filters.DueDateTo);
    const queryString = queryParams.toString();
    return request(`/verifications/audits${queryString ? '?' + queryString : ''}`);
  }

export async function getAudit(id) {
    return request(`/verifications/audits/${id}`);
  }

export async function createAudit(verificationData) {
    return request('/verifications/audits', {
      method: 'POST',
      body: JSON.stringify(verificationData),
    });
  }

export async function updateAudit(id, verificationData) {
    return request(`/verifications/audits/${id}`, {
      method: 'PUT',
      body: JSON.stringify(verificationData),
    });
  }

export async function deleteAudit(id) {
    return request(`/verifications/audits/${id}`, {
      method: 'DELETE',
    });
  }

export async function getAuditsReportData(viewMode, filters = {}) {
    const queryParams = new URLSearchParams();
    queryParams.append('viewMode', viewMode);
    queryParams.append('filters', JSON.stringify(filters));
    return request(`/verifications/dashboard/data?${queryParams.toString()}`);
  }

export async function getAuditsReportStatistics(year, filters = {}) {
    const queryParams = new URLSearchParams();
    if (year) queryParams.append('year', year);
    queryParams.append('filters', JSON.stringify(filters));
    return request(`/verifications/dashboard/statistics?${queryParams.toString()}`);
  }

export async function getAuditsModuleFilterOptions() {
    return request('/verifications/module-filter-options');
  }

export async function getAuditsReportSiteManagers(companyIds = []) {
    const queryParams = new URLSearchParams();
    if (Array.isArray(companyIds) && companyIds.length > 0) {
      queryParams.append('companyIds', companyIds.join(','));
    }
    const queryString = queryParams.toString();
    return request(`/verifications/dashboard/site-managers${queryString ? `?${queryString}` : ''}`);
  }

export const auditsApi = {
  getAudits,
  getAudit,
  createAudit,
  updateAudit,
  deleteAudit,
  getAuditsReportData,
  getAuditsReportStatistics,
  getAuditsModuleFilterOptions,
  getAuditsReportSiteManagers,
};

